import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/vc-marketplace/vc-marketplace/node_modules/next/dist/client/app-dir/link.js");
